import React, { useState, useEffect, useRef } from 'react'

export default function AudioBar({ isPlaying, height, duration, currentTime }) {
    const [translateX, setTranslateX] = useState(-2)
    const barHeight = useRef(Math.floor((height / 100) * 28) + 3).current

    useEffect(() => {
        if (isPlaying) setTranslateX(0)
    }, [isPlaying])

    useEffect(() => {
        if (currentTime === 0 && translateX === 0) {
            setTranslateX(-2)
        }
    }, [currentTime])

    return (
        <div>
            <div style={{ height: `${barHeight}px` }} className="audio-bar-played">
                <div style={{ width: '2px', height: '100%', transform: `translateX(${translateX}px)`, transition: `${duration}ms ease` }} className="bg-black"></div>
            </div>
        </div>
    )
}
